<template>
	<table class="table table-striped table-bordered table-sm" v-if="record">
        <thead class="thead-dark" v-if="showTableHeader">
            <tr>
                <th>Property</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(fieldName, index) in recordFieldsToDisplay" :key="index">
                <td><label>{{ translate('RecordManager.' + recordType + '.' + fieldName) }}</label></td>
                <td>{{ record[fieldName] }}</td>
    		</tr>
        </tbody>
	</table>
</template>

<script>
    export default {
        props: {
            record: { type: Object, required: true },
            recordType: { type: String, required: true },
            recordFieldsToDisplay: { type: Array, required: false },
            showTableHeader: { type: Boolean, required: false, default: true }
        }
    }
</script>